import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../../services/api';
import '../../v2-theme.css';
import './AuthPages.css';

/**
 * Admin Login Page
 * Matches admin-login.html exactly
 * Special gold/admin theme
 */
const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.post('/admin/login', {
        username: formData.username,
        password: formData.password
      });

      // Store admin token
      localStorage.setItem('admin_token', response.data.token);
      localStorage.setItem('admin_user', JSON.stringify(response.data.admin));

      // Redirect to admin dashboard
      navigate('/admin/dashboard');
    } catch (err) {
      console.error('Admin login error:', err);
      setError(err.response?.data?.error || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page admin-login-page" style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh'
    }}>
      <div className="auth-container" style={{ maxWidth: '500px', width: '100%' }}>
        <header className="auth-header" style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div className="auth-logo-title">
            <img src="/hotf-web-icon.png" alt="Hands On The Fly" className="auth-logo" />
            <h1>Hands On The Fly</h1>
          </div>
          <div style={{
            background: '#FFD700',
            color: '#1A1A1A',
            padding: '4px 12px',
            fontSize: '0.75rem',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            display: 'inline-block',
            marginTop: '10px'
          }}>
            Admin Access
          </div>
        </header>

        <h2 className="auth-heading" style={{ textAlign: 'center' }}>Admin Login</h2>
        <p className="auth-subtitle" style={{ textAlign: 'center', marginBottom: '40px' }}>
          Platform Management & Control
        </p>

        <form className="auth-form" onSubmit={handleSubmit} style={{
          background: 'rgba(255, 255, 255, 0.03)',
          border: '1px solid var(--dark-steel)',
          padding: '40px',
          borderRadius: '2px'
        }}>
          {error && <div className="auth-error-message">{error}</div>}

          <div className="auth-form-group">
            <label htmlFor="username">Admin Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              disabled={loading}
              style={{ borderColor: 'var(--dark-steel)' }}
            />
          </div>

          <div className="auth-form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              disabled={loading}
              style={{ borderColor: 'var(--dark-steel)' }}
            />
          </div>

          <button
            type="submit"
            className="auth-submit-btn"
            disabled={loading}
            style={{
              background: '#FFD700',
              color: '#1A1A1A',
              fontFamily: "'Oswald', sans-serif",
              fontWeight: '600',
              marginTop: '10px'
            }}
          >
            {loading ? 'Authenticating...' : 'Access Dashboard'}
          </button>
        </form>

        <p style={{
          textAlign: 'center',
          marginTop: '30px',
          color: 'var(--dark-steel)',
          fontSize: '0.85rem'
        }}>
          ⚠ Secure admin area. All actions are logged and monitored.
        </p>

        <Link to="/" style={{
          display: 'block',
          textAlign: 'center',
          marginTop: '20px',
          color: 'var(--silver)',
          fontSize: '0.9rem',
          textDecoration: 'none'
        }}>
          ← Back to Home
        </Link>
      </div>
    </div>
  );
};

export default AdminLogin;
